/**
 * Bridge for sending auth credential from webapp to the Chrome extension (tab mode).
 * Uses a custom DOM event so the extension's content script can forward it to the background.
 */

export const AUTH_RESULT_EVENT = 'shopmi-auth-result';

export const EXTENSION_TAB_MODE_KEY = 'shopmi_auth_mode';

export function dispatchAuthResultToExtension(idToken: string | null, accessToken: string | null) {
  document.dispatchEvent(
    new CustomEvent(AUTH_RESULT_EVENT, {
      detail: { idToken, accessToken },
      bubbles: true,
    })
  );
}

/** Extract Google OAuth idToken/accessToken from Firebase UserCredential (popup or redirect result) */
export function getGoogleCredentialFromResult(
  result: { credential?: { idToken?: string | null; accessToken?: string | null } | null }
): { idToken: string | null; accessToken: string | null } | null {
  const cred = result?.credential ?? null;
  if (!cred) return null;
  const id = cred.idToken ?? null;
  const access = cred.accessToken ?? null;
  if (id == null && access == null) return null;
  return { idToken: id, accessToken: access };
}
